import { defineMessages } from 'react-intl';

export const pricingPlanMessages = defineMessages({
    name: {
        id: 'name',
        defaultMessage: 'Name',
    },
    pricingPlan: {
        id: 'pricing-plan',
        defaultMessage: 'Pricing plan',
    },
    pricingPlans: {
        id: 'pricing-plans',
        defaultMessage: 'Pricing plans',
    },
    editPricingPlan: {
        id: 'edit-pricing-plan',
        defaultMessage: 'Edit pricing plan',
    },
    addPricingPlanSubtitle: {
        id: 'add-pricing-plan-subtitle',
        defaultMessage: 'Create a new pricing plan that you will be able to assign',
    },
    editPricingPlanSubtitle: {
        id: 'edit-pricing-plan-subtitle',
        defaultMessage: 'Edit pricing plan {entry}',
    },
    deletePricingPlanSubtitle: {
        id: 'delete-pricing-plan-subtitle',
        defaultMessage: 'Permanently delete pricing plan {entry}',
    },
    confirmDeletePricingPlan: {
        id: 'confirm-delete-pricing-plan',
        defaultMessage: 'Are you sure you want to delete pricing plan {entry}? This action cannot be undone.',
    },
    createPricingPlanSuccessDescription: {
        id: 'create-pricing-plan-success-description',
        defaultMessage: 'Pricing plan {entry} has been successfully created.',
    },
    updatePricingPlanSuccessDescription: {
        id: 'update-pricing-plan-success-description',
        defaultMessage: 'Pricing plan {entry} has been successfully updated.',
    },
    deletePricingPlanSuccessDescription: {
        id: 'delete-pricing-plan-success-description',
        defaultMessage: 'Pricing plan {entry} has been successfully deleted.',
    },
    createPricingPlanSuccess: {
        id: 'create-pricing-plan-success',
        defaultMessage: 'Pricing plan created',
    },
    updatePricingPlanSuccess: {
        id: 'update-pricing-plan-success',
        defaultMessage: 'Pricing plan updated',
    },
    deletePricingPlanSuccess: {
        id: 'delete-pricing-plan-success',
        defaultMessage: 'Pricing plan deleted',
    },
    dashboard: {
        id: 'dashboard',
        defaultMessage: 'Dashboard',
    },
    plan: {
        id: 'plan',
        defaultMessage: 'Plan',
    },
    plans: {
        id: 'plans',
        defaultMessage: 'Plans',
    },
    billingType: {
        id: 'billing-type',
        defaultMessage: 'Billing type',
    },
    versionNumber: {
        id: 'version-number',
        defaultMessage: 'Version number',
    },
    activeFrom: {
        id: 'active-from',
        defaultMessage: 'Active from',
    },
    activeTo: {
        id: 'active-to',
        defaultMessage: 'Active to',
    },
    calculationType: {
        id: 'calculation-type',
        defaultMessage: 'Calculation type',
    },
    postBilling: {
        id: 'post-billing',
        defaultMessage: 'Post-billings',
    },
    preBilling: {
        id: 'pre-billing',
        defaultMessage: 'Pre-billings',
    },
    fixedTick: {
        id: 'fixed-tick',
        defaultMessage: 'Fixed tick',
    },
    compoundPeriods: {
        id: 'compound-periods',
        defaultMessage: 'Compound periods',
    },
    totalPeriods: {
        id: 'total-periods',
        defaultMessage: 'Total periods',
    },
    scheduledChanges: {
        id: 'scheduled-changes',
        defaultMessage: 'Scheduled changes',
    },
    currentVersion: {
        id: 'current-version',
        defaultMessage: 'Current version',
    },
    none: {
        id: 'none',
        defaultMessage: 'None',
    },
    repeating: {
        id: 'repeating',
        defaultMessage: 'Repeating',
    },
    oneTime: {
        id: 'one-time',
        defaultMessage: 'One time',
    },
    capping: {
        id: 'capping',
        defaultMessage: 'Capping',
    },
    currency: {
        id: 'currency',
        defaultMessage: 'Currency',
    },
    pricingPlanDashboard: {
        id: 'pricing-plan-dashboard',
        defaultMessage: 'Pricing plan dashboard',
    },
    createNewVersion: {
        id: 'create-new-version',
        defaultMessage: 'Create new version',
    },
    allVersions: {
        id: 'all-versions',
        defaultMessage: 'All versions',
    },
    status: {
        id: 'status',
        defaultMessage: 'Status',
    },
    freeTimeType: {
        id: 'free-time-type',
        defaultMessage: 'Free time type',
    },
    freeTime: {
        id: 'free-time',
        defaultMessage: 'Free time',
    },
    freeTimeCap: {
        id: 'free-time-cap',
        defaultMessage: 'Free time cap',
    },
    exitTime: {
        id: 'exit-time',
        defaultMessage: 'Exit time',
    },
    exitTimeGrace: {
        id: 'exit-time-grace',
        defaultMessage: 'Exit time grace',
    },
    validFromPricing: {
        id: 'valid-from-pricing',
        defaultMessage: 'Valid from',
    },
    validToPricing: {
        id: 'valid-to-pricing',
        defaultMessage: 'Valid to',
    },
    previousVersion: {
        id: 'previous-version',
        defaultMessage: 'Previous version',
    },
    nextVersion: {
        id: 'next-version',
        defaultMessage: 'Next version',
    },
    description: {
        id: 'description',
        defaultMessage: 'Description',
    },
    draft: {
        id: 'draft',
        defaultMessage: 'Draft',
    },
    published: {
        id: 'published',
        defaultMessage: 'Published',
    },
    adjustments: {
        id: 'adjustments',
        defaultMessage: 'Adjustments',
    },
    adjustment: {
        id: 'adjustment',
        defaultMessage: 'Adjustment',
    },
    everyVisit: {
        id: 'every-visit',
        defaultMessage: 'Every visit',
    },
    pastVersion: {
        id: 'past-version',
        defaultMessage: 'Past version',
    },
    tickType: {
        id: 'tick-type',
        defaultMessage: 'Tick type',
    },
    tickDuration: {
        id: 'tick-duration',
        defaultMessage: 'Tick duration',
    },
    perMinute: {
        id: 'per-minute',
        defaultMessage: 'Per minute',
    },
    hourly: {
        id: 'hourly',
        defaultMessage: 'Hourly',
    },
    daily: {
        id: 'daily',
        defaultMessage: 'Daily',
    },
    weekly: {
        id: 'weekly',
        defaultMessage: 'Weekly',
    },
    monthly: {
        id: 'monthly',
        defaultMessage: 'Monthly',
    },
    rates: {
        id: 'rates',
        defaultMessage: 'Rates',
    },
    rate: {
        id: 'rate',
        defaultMessage: 'Rate',
    },
    hours: {
        id: 'hours',
        defaultMessage: 'Hours',
    },
    day: {
        id: 'day',
        defaultMessage: 'Day',
    },
    createTickRateSuccess: {
        id: 'create-tick-rate-success',
        defaultMessage: 'Rate created',
    },
    createTickRateSuccessDescription: {
        id: 'create-tick-rate-success-description',
        defaultMessage: 'A new rate has been successfully created.',
    },
    addRateSubtitle: {
        id: 'add-rate-subtitle',
        defaultMessage: 'Add a new rate to this pricing plan',
    },
    fromHour: {
        id: 'from-hour',
        defaultMessage: 'From',
    },
    toHour: {
        id: 'to-hour',
        defaultMessage: 'To',
    },
    deleteTickRateSuccess: {
        id: 'delete-tick-rate-success',
        defaultMessage: 'Rate deleted',
    },
    deleteTickRateSuccessDescription: {
        id: 'delete-tick-rate-success-description',
        defaultMessage: 'Rate has been successfully deleted.',
    },
    deleteTickRateSubtitle: {
        id: 'delete-tick-rate-subtitle',
        defaultMessage: 'Permanently delete rate',
    },
    confirmDeleteTickRate: {
        id: 'confirm-delete-tick-rate',
        defaultMessage: 'Are you sure you want to delete this rate? This action cannot be undone.',
    },
    updateRateSuccess: {
        id: 'update-rate-success',
        defaultMessage: 'Rate updated',
    },
    updateRateSuccessDescription: {
        id: 'update-rate-success-description',
        defaultMessage: 'The rate has been successfully updated.',
    },
    editRateSubtitle: {
        id: 'edit-rate-subtitle',
        defaultMessage: 'Edit the details',
    },
    taxPercent: {
        id: 'tax-percent',
        defaultMessage: 'VAT %',
    },
    validity: {
        id: 'validity',
        defaultMessage: 'Validity',
    },
    rules: {
        id: 'rules',
        defaultMessage: 'Rules',
    },
    taxAttributes: {
        id: 'tax-attributes',
        defaultMessage: 'Tax attributes',
    },
    eur: {
        id: 'eur',
        defaultMessage: 'Euro',
    },
    minutes: {
        id: 'minutes',
        defaultMessage: 'Minutes',
    },
    capped: {
        id: 'capped',
        defaultMessage: 'Capped',
    },
    validFrom: {
        id: 'valid-from',
        defaultMessage: 'Valid from',
    },
    validTo: {
        id: 'valid-to',
        defaultMessage: 'Valid to',
    },
    hour: {
        id: 'hour',
        defaultMessage: 'Hour',
    },
    minute: {
        id: 'minute',
        defaultMessage: 'Minute',
    },
    week: {
        id: 'week',
        defaultMessage: 'Week',
    },
    month: {
        id: 'month',
        defaultMessage: 'Month',
    },
    tiers: {
        id: 'tiers',
        defaultMessage: 'Tiers',
    },
    caps: {
        id: 'caps',
        defaultMessage: 'Caps',
    },
    pricingPlanVersionControl: {
        id: 'pricing-plan-version-control',
        defaultMessage: 'Pricing plan version control',
    },
    editPricingPlanVersion: {
        id: 'edit-pricing-plan-version',
        defaultMessage: 'Edit pricing plan version',
    },
    pricingPlanVersion: {
        id: 'pricing-plan-version',
        defaultMessage: 'Pricing plan version',
    },
    pricingPlanVersions: {
        id: 'pricing-plan-versions',
        defaultMessage: 'Pricing plan versions',
    },
    addPricingPlanVersionSubtitle: {
        id: 'add-pricing-plan-version-subtitle',
        defaultMessage: 'Create a new pricing plan version',
    },
    createPricingPlanVersionSuccess: {
        id: 'create-pricing-plan-version-success',
        defaultMessage: 'Pricing plan version created',
    },
    createPricingPlanVersionSuccessDescription: {
        id: 'create-pricing-plan-version-success-description',
        defaultMessage: 'Pricing plan version {entry} has been successfully created.',
    },
    updatePricingPlanVersionSuccess: {
        id: 'update-pricing-plan-version-success',
        defaultMessage: 'Pricing plan version updated',
    },
    updatePricingPlanVersionSuccessDescription: {
        id: 'update-pricing-plan-version-success-description',
        defaultMessage: 'Pricing plan version {entry} has been successfully updated.',
    },
    editPricingPlanVersionSubtitle: {
        id: 'edit-pricing-plan-version-subtitle',
        defaultMessage: 'Edit pricing plan version {entry}',
    },
    deletePricingPlanVersionSubtitle: {
        id: 'delete-pricing-plan-version-subtitle',
        defaultMessage: 'Permanently delete pricing plan version {entry}',
    },
    confirmDeletePricingPlanVersion: {
        id: 'confirm-delete-pricing-plan-version',
        defaultMessage: 'Are you sure you want to delete pricing plan version {entry}? This action cannot be undone.',
    },
    deletePricingPlanVersionSuccess: {
        id: 'delete-pricing-plan-version-success',
        defaultMessage: 'Pricing plan version deleted',
    },
    deletePricingPlanVersionSuccessDescription: {
        id: 'delete-pricing-plan-success-version-description',
        defaultMessage: 'Pricing plan version {entry} has been successfully deleted.',
    },
    copyPricingPlanVersionSubtitle: {
        id: 'copy-pricing-plan-version-subtitle',
        defaultMessage: 'Copy pricing plan version {entry}',
    },
    copyPricingPlanVersionSuccess: {
        id: 'copy-pricing-plan-version-success',
        defaultMessage: 'Pricing plan version copied',
    },
    copyPricingPlanVersionSuccessDescription: {
        id: 'copy-pricing-plan-version-success-description',
        defaultMessage: 'Pricing plan version {entry} has been successfully copied.',
    },
    cash: {
        id: 'cash',
        defaultMessage: 'Cash',
    },
    card: {
        id: 'card',
        defaultMessage: 'Card',
    },
    bank: {
        id: 'bank',
        defaultMessage: 'Bank',
    },
    web: {
        id: 'web',
        defaultMessage: 'Web',
    },
    paymentType: {
        id: 'payment-type',
        defaultMessage: 'Payment type',
    },
    adjustmentPercent: {
        id: 'adjustment-percent',
        defaultMessage: 'Percent',
    },
    adjustmentAmount: {
        id: 'adjustment-amount',
        defaultMessage: 'Amount',
    },
    createAdjustmentSuccess: {
        id: 'create-adjustment-success',
        defaultMessage: 'Adjustment created',
    },
    createAdjustmentSuccessDescription: {
        id: 'create-adjustment-success-description',
        defaultMessage: 'A new adjustment has been successfully created.',
    },
    addAdjustmentSubtitle: {
        id: 'add-adjustment-subtitle',
        defaultMessage: 'Add a new adjustment to this pricing plan',
    },
    deleteAdjustment: {
        id: 'delete-adjustment',
        defaultMessage: 'Delete adjustment',
    },
    deleteAdjustmentSuccess: {
        id: 'delete-adjustment-success',
        defaultMessage: 'Adjustment deleted',
    },
    deleteAdjustmentSuccessDescription: {
        id: 'delete-adjustment-success-description',
        defaultMessage: 'The adjustment has been successfully deleted.',
    },
    deleteAdjustmentSubtitle: {
        id: 'delete-adjustment-subtitle',
        defaultMessage: 'Permanently delete adjustment',
    },
    confirmDeleteAdjustment: {
        id: 'confirm-delete-adjustment',
        defaultMessage: 'Are you sure you want to delete this adjustment? This action cannot be undone.',
    },
    updateAdjustmentSuccess: {
        id: 'update-adjustment-success',
        defaultMessage: 'Adjustment updated',
    },
    updateAdjustmentSuccessDescription: {
        id: 'update-adjustment-success-description',
        defaultMessage: 'The adjustment has been successfully updated.',
    },
    editAdjustmentSubtitle: {
        id: 'edit-adjustment-subtitle',
        defaultMessage: 'Edit the details of this adjustment',
    },
    adjustmentPercentError: {
        id: 'custom-error:adjustment_percent',
        defaultMessage: 'Ensure this value is greater than or equal to -100.00.',
    },
    fixedPrice: {
        id: 'fixed-price',
        defaultMessage: 'Fixed price',
    },
    price: {
        id: 'price',
        defaultMessage: 'Price',
    },
    publish: {
        id: 'publish',
        defaultMessage: 'Publish',
    },
    publishPlan: {
        id: 'publish-plan',
        defaultMessage: 'Publish plan {entry}',
    },
    confirmPublishPlan: {
        id: 'confirm-publish-plan',
        defaultMessage: 'Are you sure you want to publish pricing plan {entry}?',
    },
    publishPricingPlanSuccess: {
        id: 'publish-pricing-plan-success',
        defaultMessage: 'Pricing plan published',
    },
    publishPricingPlanSuccessDescription: {
        id: 'publish-pricing-plan-success-description',
        defaultMessage: 'Pricing plan {entry} has been successfully published.',
    },
    tickRateOverlapError: {
        id: 'custom-error:pricing_plan_tick_rate_overlap',
        defaultMessage: 'The times of the tick rate are overlapping with another tick rate.',
    },
});
